import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Récupère le token utilisateur/admin depuis localStorage.
 * On garde sf_token en priorité, mais on vérifie aussi d'autres clés possibles
 * pour éviter les erreurs 401 si certaines parties du site utilisent un autre nom.
 */
export const getAuthToken = () => {
  return (
    localStorage.getItem("sf_token") ||
    localStorage.getItem("token") ||
    localStorage.getItem("access_token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("sflearning_token") ||
    ""
  );
};

/**
 * Headers d'auth réutilisables si un fichier utilise encore axios directement.
 */
export const authHeaders = () => {
  const token = getAuthToken();

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

export const api = axios.create({
  baseURL: `${BASE}/api`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Inject Bearer token from localStorage if present
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      console.warn(
        "Requête non autorisée : token absent, expiré ou non envoyé.",
        error.config?.url
      );
    }

    if (status === 403) {
      console.warn(
        "Accès refusé : rôle insuffisant pour cette ressource.",
        error.config?.url
      );
    }

    if (status === 404) {
      console.warn(
        "Route API introuvable :",
        error.config?.url
      );
    }

    return Promise.reject(error);
  }
);

export const fileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  return `${BASE}${path}`;
};

export default api;